<div *ngIf="concluida" class="form-content sucesso-content">
  <div class="sucesso-icon-text">
    <img
      src="{{ BASE_IMG_URL }}assets/img-ficha-obra/concluido.png"
      alt="Sucesso"
      class="sucesso-icon"
    />
    <span class="sucesso-msg">Tarefa concluída com sucesso!</span>
  </div>
  <div class="footer-actions-continuar">
    <button class="btn btn-primary" type="button" (click)="continuar()">
      CONTINUAR
    </button>
  </div>
</div>
